enum ModalName {
    NETWORKING_HELP = 'NetworkingHelpModal',
    MEDIA_SYSTEM_CHECK = 'MediaSystemCheckModal',
    AUTH_MODAL = 'AuthModal',
    NATIONALITY = 'modal-nationality',
    LANGUAGES = 'modal-languages',
    CONNECT = 'modal-connect',
    EDIT_LOCATION = 'modal-edit-location',
    EDIT_COMPANY = 'modal-edit-company',
    EDIT_INTERESTS = 'edit-interests',
    DELETE_EXPERIENCE = 'modal-delete-experience',
    WORKSPACE_BOOK = 'modal-workspace-book',
    SEND_RELATIONSHIP_UNRESPONDED_FEEDBACK = 'modal-send-relationship-unresponded-feedback',
    PROJECT_HELP = 'modal-project-help',
    PROJECT_INTERESTED = 'modal-project-interested',
    CLUB_ASK_TO_JOIN = 'modal-club-ask-to-join',
    CLUB_PAYMENT = 'modal-club-payment',
    TRIP_CANCEL = 'modal-trip-cancel',
    REFER_IMPORT_GMAIL = 'modal-refer-import-gmail',
    REFER_IMPORT_OUTLOOK = 'modal-refer-import-outlook',
    COMPANY_CONTACT = 'modal-company-contact',
    COMPANY_APPLY = 'modal-company-apply',
    APPLY_LOST = 'modal-apply-lost',
    APPLY_ALREADY_EXIST = 'modal-apply-already-exist',
    PREVIEW = 'modal-preview',
    CONFIRM = 'modal-confirm',
    UPDATE_ACCOUNT_AVATAR = 'modal-update-account-avatar',
    CRITERIAS = 'modal-criterias',
    STAKES = 'modal-stakes',
    FEEDBACK = 'modal-feedback', // post MER & post event
    SEND_AGREEMENT_NEED = 'send-agreement-need',
    MODAL_CONTACT_US = 'modal-contact-us',
    DEVICE_ERROR = 'modal-device-error',
    CHARTER_LECLUB = 'modal-charter-leclub',
    ONBOARDING_INVESTORS_CLUB = 'modal-onboarding-investors-club',
    PROJECT_GET_CONTACT = 'modal-project-get-contact',
    CLUB_UPGRADE = 'modal-club-upgrade',
}

export default ModalName
